import React from 'react';
import IframeViewer from './IframeViewer';
import VideoPlayer from './VideoPlayer';
import VideoPlayerEndSlate from './VideoPlayerEndSlate';
import AssetLink from './AssetLink';

require('../../css/components/AssetDetails.scss');

'use strict';

export default class AssetDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = { languageUrls: props.languageUrls, asset: props.asset, loaded: props.asset !== null, loading: false };

        this.setPlayerRef = this.setPlayerRef.bind(this);
        this.getBestLanguage = this.getBestLanguage.bind(this);
        this.sendGTMEvent = this.sendGTMEvent.bind(this);
        this.onNewAsset = this.onNewAsset.bind(this);
        this.onVideoStarted = this.onVideoStarted.bind(this);
        this.onVideoPlaying = this.onVideoPlaying.bind(this);
        this.onVideoProgress = this.onVideoProgress.bind(this);
        this.onVideoEnded = this.onVideoEnded.bind(this);
        this.onQuestionAsked = this.onQuestionAsked.bind(this);
        this.onQuestionAnsweredCorrectly = this.onQuestionAnsweredCorrectly.bind(this);
        this.onQuestionAnsweredIncorrectly = this.onQuestionAnsweredIncorrectly.bind(this);
        this.onOpenPDF = this.onOpenPDF.bind(this);
    }

    componentDidMount() {
        if (this.state.loaded && !this.props.embedded)
            this.sendGTMEvent('customPageview', this.populateDataLayer(this.state.asset));
    }

    componentDidUpdate(prevProps) {
        var bookmark = this.props.progressBookmark;

        if (this.playerRef && bookmark)
            this.playerRef.updateBookmark(bookmark);

        if (this.props.apiUrl && this.props.apiUrl !== prevProps.apiUrl)
            this.loadData(bookmark);
    }

    loadData(bookmark) {
        this.setState({
            loading: true,
            loaded: false
        });

        fetch(this.props.apiUrl)
            .then(response => response.json())
            .then(
                (response) => {
                    var result = response.assets[0];

                    this.setState({
                        loading: false,
                        loaded: true,
                        languageUrls: result.languageUrls,
                        asset: result.asset
                    });

                    if (this.playerRef)
                        this.playerRef.updateIsci(result.asset.isci, this.getBestLanguage(result.asset, this.props.language), bookmark);

                    this.onNewAsset(result.asset);
                },
                (error) => {
                    this.setState({
                        loading: false,
                        loaded: false
                    });
                }
            );
    }

    setPlayerRef(ref) {
        this.playerRef = ref;
    }

    getBestLanguage(asset, preferredLanguage) {
        preferredLanguage = preferredLanguage || "en-US";
        if (asset.languages.indexOf(preferredLanguage) > -1)
            return preferredLanguage;
        else
            return asset.languages[0];
    }

    sendGTMEvent(eventName, clientSideDataLayer) {
        clientSideDataLayer = clientSideDataLayer || this.props.clientSideDataLayer;
        var serverSideDataLayer = this.props.serverSideDataLayer;

        clientSideDataLayer['event'] = eventName;

        this.props.dataLayer.push(Object.assign({}, serverSideDataLayer, clientSideDataLayer));
    }

    // TODO:  Shouldn't be relying on side effects here.
    populateDataLayer(asset) {
        var dataLayer = this.props.clientSideDataLayer;

        dataLayer['subject'] = asset.englishSubject;
        dataLayer['subjectTopic'] = asset.englishSubject + ' | ' + asset.englishTopic;
        dataLayer['assetId'] = asset.keyID;
        dataLayer['assetTitle'] = asset.englishTitle;
        dataLayer['assetType'] = asset.type;
        dataLayer['assetLanguage'] = this.props.languageNames[this.props.language || "en-US"];
        dataLayer['versionId'] = asset.isci;

        return dataLayer;
    }

    onNewAsset(asset) {
        if (!this.props.embedded)
            this.sendGTMEvent('customPageview', this.populateDataLayer(asset));

        if (this.props.onNewAsset)
            this.props.onNewAsset(asset);
    }

    onVideoStarted() {
        this.sendGTMEvent('videoViewStart');

        if (this.props.onVideoStarted)
            this.props.onVideoStarted();
    }

    onVideoPlaying(currentTime, totalDuration) {
        this.playerRef.hideEndSlate();

        if (this.props.onVideoPlaying)
            this.props.onVideoPlaying(currentTime, totalDuration);
    }

    onVideoProgress(timeViewed, totalDuration, percentageViewed, beginningAtTime) {
        var clientSideDataLayer = this.props.clientSideDataLayer;

        clientSideDataLayer['videoTimeViewed'] = Math.round(timeViewed);
        clientSideDataLayer['videoPercentageViewed'] = Math.round(percentageViewed);

        this.sendGTMEvent('videoViewProgress');

        this.props.user.reportAssignmentProgress(
            this.props.clientSideDataLayer['assetId'], this.props.assignment, this.props.assignmentItem,
            Math.round(beginningAtTime), Math.round(timeViewed), Math.round(totalDuration)
        );

        if (this.props.onVideoProgress)
            this.props.onVideoProgress(timeViewed, totalDuration, percentageViewed, beginningAtTime);
    }

    onOpenPDF() {
        this.props.user.reportAssignmentProgress(this.props.clientSideDataLayer['assetId'], this.props.assignment, this.props.assignmentItem, 0.0, 1.0, 1.0);

        return true;
    }

    onVideoEnded() {
        this.sendGTMEvent('videoViewEnd');

        var nextAsset = this.props.nextAsset;

        this.playerRef.showEndSlate(
            React.createElement(VideoPlayerEndSlate, {
                copy: this.props.copy,
                upNextCountdown: this.props.endSlateUpNextCountdown,
                question: this.props.question,
                answers: this.props.answers,
                correctAnswer: this.props.correctAnswer,
                onQuestionAsked: this.onQuestionAsked,
                onQuestionAnsweredCorrectly: this.onQuestionAnsweredCorrectly,
                onQuestionAnsweredIncorrectly: this.onQuestionAnsweredIncorrectly,
                showUpNext: this.props.showUpNext,
                answerFollowup: !this.props.answerFollowup ? null : () => {
                    return <div>
                        <div>
                            Thank you for your feedback.
                        </div>
                        {
                            this.props.assignment.displayNextAssignment ?
                                <div>
                                    <AssetLink title="Continue to next Assignment" className="btn btn-outline-primary btn-lg my-3" assignment={this.props.assignment.displayNextAssignment} asset={this.props.assignment.displayNextAssignment.displayResumeItem.asset} urlHash={this.props.location.hash} />
                                </div> :
                                <div>
                                    <div>
                                        We have a great library! We invite you to check it out.
                                    </div>
                                    <a href={this.props.libraryUrl} className="btn btn-outline-primary btn-lg" role="button" aria-pressed="true">{this.props.copy.viewLibrary}</a>
                                </div>
                        }
                    </div>;
                },
                nextAsset:
                    nextAsset ?
                        {
                            url: nextAsset.urlWithHash || (nextAsset.url + this.props.location.hash),
                            asset: { title: nextAsset.asset.title }
                        } :
                        null
            }));

        if (this.props.onVideoEnded)
            this.props.onVideoEnded();
    }

    onQuestionAsked() {
        this.sendGTMEvent('videoQuestionAsked');

        if (this.props.onQuestionAsked)
            this.props.onQuestionAsked();
    }

    onQuestionAnsweredCorrectly() {
        this.sendGTMEvent('videoQuestionAnsweredCorrectly');

        this.props.user.reportAssessmentResult(this.props.assignment, this.props.assignmentItem, this.props.assessment, true);

        if (this.props.onQuestionAnsweredCorrectly)
            this.props.onQuestionAnsweredCorrectly();
    }

    onQuestionAnsweredIncorrectly() {
        this.props.user.reportAssessmentResult(this.props.assignment, this.props.assignmentItem, this.props.assessment, false);

        if (this.props.onQuestionAnsweredIncorrectly)
            this.props.onQuestionAnsweredIncorrectly();
    }

    render() {
        var bestLanguage = this.getBestLanguage(this.state.asset, this.props.language);

        var heading = [];

        if (!this.props.embedded) {
            heading.push(React.createElement('h1', {}, this.state.asset.title));

            if (this.state.asset.type === "PDF")
                heading.push(
                    React.createElement('a',
                        {
                            className: "open-pdf",
                            href: bestLanguage === "es-US" ? this.state.asset.spanishTranscriptPath : this.state.asset.englishTranscriptPath,
                            target: "_blank",
                            onClick: (e) => {
                                this.onOpenPDF();
                            }
                        },
                        this.props.copy.openDocument
                    ));
        }

        var transcripts = [];

        if (this.state.asset.type === "Video") {
            if (this.state.asset.englishTranscriptPath)
                transcripts.push(
                    React.createElement(
                        'a',
                        { target: "_blank", href: this.state.asset.englishTranscriptPath, className: "transcript" + ((this.state.asset.spanishTranscriptPath) ? " separator" : "") },
                        'English'));

            if (this.state.asset.spanishTranscriptPath)
                transcripts.push(
                    React.createElement(
                        'a',
                        { target: "_blank", href: this.state.asset.spanishTranscriptPath, className: "transcript" },
                        'Español'));
        }

        var languages = [];

        this.state.asset.languages.forEach(
            function (language, l, a) { 
                languages.push(
                    React.createElement(
                        'a',
                        { href: this.state.languageUrls[language] + this.props.location.hash, className: (l < a.length - 1) ? "separator" : null},
                        this.props.languageNames[language]));
            }.bind(this));

        return React.createElement(
            'div',
            {
            },
            [
                this.state.asset.type === "Video" ?
                    React.createElement(
                        'div',
                        {
                            className: 'player-container' + (this.props.embedded ? '' : ' mb-3'),
                            style: { position: this.props.embedded ? 'absolute' : 'relative', overflow: 'hidden', width: '100%', paddingBottom: this.props.embedded ? '0' : '56.25%', height: this.props.embedded ? '100%' : 'auto' }
                        },
                        React.createElement(
                            'div',
                            {
                            },
                            React.createElement(
                                VideoPlayer,
                                {
                                    asset: this.state.asset,
                                    language: bestLanguage,
                                    ref: this.setPlayerRef,
                                    autoPlay: this.props.autoPlayVideo,
                                    seekToBookmark: this.props.progressBookmark,
                                    onVideoStarted: this.onVideoStarted,
                                    onVideoPlaying: this.onVideoPlaying,
                                    onVideoProgress: this.onVideoProgress,
                                    onVideoEnded: this.onVideoEnded
                                })
                        )
                    ) :
                    this.state.asset.type === "3D Interactive" ?
                        React.createElement(
                            'div',
                            {
                                className: 'player-container mb-3',
                                style: { position: 'relative', overflow: 'hidden', width: '100%', paddingBottom: '56.25%', height: 'auto' }
                            },
                            React.createElement(
                                IframeViewer,
                                {
                                    metadataUrl: this.state.asset.metadataPath
                                })
                        ) :
                        React.createElement(
                            'div',
                            {
                                className: (this.props.embedded ? 'my-1' : ' mb-3')
                            },
                            this.state.asset.hasPosterImage ?
                                React.createElement(
                                    'a',
                                    {
                                        target: '_blank',
                                        href: bestLanguage === "es-US" ? this.state.asset.spanishTranscriptPath : this.state.asset.englishTranscriptPath
                                    },
                                    this.state.asset.hasPosterImage ?
                                        React.createElement(
                                            'img',
                                            {
                                                className: "poster", src: this.state.asset.posterImagePath
                                            }
                                        ) : "PDF Details"
                                ) : "PDF Details"
                        ),
                React.createElement('div', { className: 'heading' }, heading),
                React.createElement(
                    'div',
                    {
                        className: 'asset-metadata-container' + (this.props.embedded ? ' embedded' : '')
                    },
                    [
                        this.props.embedded ?
                            React.createElement(
                                'button',
                                {
                                    className: 'info-button', 'aria-expanded': true, 'aria-controls': 'assetMetadata-collapse', type: 'button', 'data-target': '#assetMetadata-collapse', 'data-toggle': 'collapse'
                                }) :
                            null,
                        React.createElement(
                            'div',
                            {
                                id: 'assetMetadata-collapse', className: 'asset-metadata' + (this.props.embedded ? ' collapse' : '')
                            },
                            React.createElement(
                                'div',
                                {
                                    id: 'assetMetadata', className: 'description-languages-transcripts-share'
                                },
                                [
                                    this.props.embedded ?
                                        React.createElement(
                                            'div',
                                            {
                                            },
                                            [
                                                React.createElement(
                                                    'h2',
                                                    {},
                                                    this.props.copy.title),
                                                React.createElement(
                                                    'p',
                                                    {},
                                                    this.state.asset.title)
                                            ]) :
                                        null,
                                    this.state.asset.description ?
                                        React.createElement(
                                            'div',
                                            {
                                                className: (this.props.embedded ? 'my-1' : ' my-3')
                                            },
                                            [
                                                React.createElement(
                                                    'p',
                                                    {},
                                                    this.state.asset.description)
                                            ]) :
                                        null,
                                    React.createElement(
                                        'div',
                                        {
                                            className: 'languages-transcripts-share + ' + (this.props.embedded ? 'my-1' : ' my-3')
                                        },
                                        [
                                            React.createElement(
                                                'div',
                                                {
                                                    className: 'languages-share'
                                                },
                                                [
                                                    React.createElement(
                                                        'div',
                                                        {
                                                            className: 'd-flex flex-row flex-wrap languages'
                                                        },
                                                        [
                                                            React.createElement(
                                                                'h2',
                                                                { className: "mt-2 mb-0" },
                                                                this.props.copy.availableLanguages + ':'),
                                                            React.createElement(
                                                                'div',
                                                                { className: "d-flex flex-row flex-wrap mt-2 mb-0" },
                                                                languages
                                                            )
                                                        ]),
                                                    !this.props.embedded ?
                                                        React.createElement(
                                                            'div',
                                                            {
                                                                className: 'share'
                                                            },
                                                            React.createElement(
                                                                'a',
                                                                { className: "shareButton", href: "#", "data-toggle": "modal", "data-target": "#share-dialog" },
                                                                this.props.copy.share
                                                            )
                                                        ) :
                                                        null
                                                ]
                                            ),
                                            transcripts.length && !this.props.embedded ?
                                                React.createElement(
                                                    'div',
                                                    {
                                                        className: 'transcripts'
                                                    },
                                                    [
                                                        React.createElement(
                                                            'h2',
                                                            {},
                                                            this.props.copy.availableTranscripts),
                                                        React.createElement(
                                                            'div',
                                                            { className: "flex flex-row" },
                                                            transcripts
                                                        )
                                                    ]
                                                ) : null
                                        ]
                                    )
                                ]
                            )
                        )
                    ]
                )
            ]
        );
    }
}